export const GET_REQUIREMENTS = 'form-requirements/GET_REQUIREMENTS';